/** Up to two initials for an avatar: "Wanjiru Kamau" → "WK", "Otieno" → "O". Falls back to the email's first letter. */
export function initials(name: string, email = ''): string {
  const letters = name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0]);
  const picked = letters.length > 1 ? [letters[0], letters[letters.length - 1]] : letters;
  return (picked.join('') || email.charAt(0)).toUpperCase();
}
